import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { MarketingAnalyticsEvent, MarketingAnalyticsEventType } from './marketingAnalyticsEventTypes';

export class MarketingAnalyticsChatInitEventType extends MarketingAnalyticsEventType {
    canHandle(event: any): boolean {
        return event.topic === AnalyticsEventTopic.ANALYTICS_CHAT_INIT;
    }

    getBody(event: any): MarketingAnalyticsEvent {
        return this.baseEvent(event);
    }
}
